/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoEfsModelsMappingFileAttribute,
    EfsMelcoEfsModelsMappingFileAttributeFromJSON,
    EfsMelcoEfsModelsMappingFileAttributeFromJSONTyped,
    EfsMelcoEfsModelsMappingFileAttributeToJSON,
    EfsMelcoEfsModelsSchemaListItem,
    EfsMelcoEfsModelsSchemaListItemFromJSON,
    EfsMelcoEfsModelsSchemaListItemFromJSONTyped,
    EfsMelcoEfsModelsSchemaListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoEfsModelsCreateFormat
 */
export interface EfsMelcoEfsModelsCreateFormat {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsCreateFormat
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsCreateFormat
     */
    display_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsCreateFormat
     */
    xml_orders_xpath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsCreateFormat
     */
    unique_field?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EfsMelcoEfsModelsCreateFormat
     */
    headers?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsCreateFormat
     */
    type?: string | null;
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsSchemaListItem>}
     * @memberof EfsMelcoEfsModelsCreateFormat
     */
    schema_list?: Array<EfsMelcoEfsModelsSchemaListItem> | null;
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsMappingFileAttribute>}
     * @memberof EfsMelcoEfsModelsCreateFormat
     */
    filename_rules_list?: Array<EfsMelcoEfsModelsMappingFileAttribute> | null;
}

export function EfsMelcoEfsModelsCreateFormatFromJSON(json: any): EfsMelcoEfsModelsCreateFormat {
    return EfsMelcoEfsModelsCreateFormatFromJSONTyped(json, false);
}

export function EfsMelcoEfsModelsCreateFormatFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoEfsModelsCreateFormat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'display_name': !exists(json, 'display_name') ? undefined : json['display_name'],
        'xml_orders_xpath': !exists(json, 'xml_orders_xpath') ? undefined : json['xml_orders_xpath'],
        'unique_field': !exists(json, 'unique_field') ? undefined : json['unique_field'],
        'headers': !exists(json, 'headers') ? undefined : json['headers'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'schema_list': !exists(json, 'schema_list') ? undefined : (json['schema_list'] === null ? null : (json['schema_list'] as Array<any>).map(EfsMelcoEfsModelsSchemaListItemFromJSON)),
        'filename_rules_list': !exists(json, 'filename_rules_list') ? undefined : (json['filename_rules_list'] === null ? null : (json['filename_rules_list'] as Array<any>).map(EfsMelcoEfsModelsMappingFileAttributeFromJSON)),
    };
}

export function EfsMelcoEfsModelsCreateFormatToJSON(value?: EfsMelcoEfsModelsCreateFormat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'display_name': value.display_name,
        'xml_orders_xpath': value.xml_orders_xpath,
        'unique_field': value.unique_field,
        'headers': value.headers,
        'type': value.type,
        'schema_list': value.schema_list === undefined ? undefined : (value.schema_list === null ? null : (value.schema_list as Array<any>).map(EfsMelcoEfsModelsSchemaListItemToJSON)),
        'filename_rules_list': value.filename_rules_list === undefined ? undefined : (value.filename_rules_list === null ? null : (value.filename_rules_list as Array<any>).map(EfsMelcoEfsModelsMappingFileAttributeToJSON)),
    };
}


